/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 保存用户登录记录日志
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  cuMemberLoginLogRequest: member.CuMemberLoginLogRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/member-login-log/save`,
    data: cuMemberLoginLogRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
